<template>
  <div>
    <!-- 驳回原因提示 -->
    <el-alert
      v-if="mode === 'resubmit' && preprintData && preprintData.auditOpinion"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 10px"
    >
      <template slot="default">
        <div style="line-height: 1.8; color: #606266">
          <span style="font-weight: 600; color: #E6A23C">重新提交预印本</span>
          <span style="margin: 0 8px; color: #909399">|</span>
          <span style="font-weight: 500; color: #606266">驳回原因：</span>
          <span style="color: #606266">{{ preprintData.auditOpinion }}</span>
        </div>
      </template>
    </el-alert>

    <el-col :span="6" class="mydoc title">
       <el-col class="header jump" @click.native="goBack()">
         <i class="el-icon-s-home"></i> &nbsp;{{ $t('preprint.backToMyPreprint') }}
      </el-col>

      <el-col
        @click.native="currentComponent = 'preprintInfoComponent'"
        :class="{ active: currentComponent === 'preprintInfoComponent' }"
        class="catelog"
      >
        <span class="catelog_text">{{ $t('preprint.submitStepsInfo') }}</span>
        <el-divider></el-divider>
      </el-col>

      <el-col
        @click.native="currentComponent = 'preprintAuthorComponent'"
        :class="{ active: currentComponent === 'preprintAuthorComponent' }"
        class="catelog"
      >
        <span class="catelog_text">{{ $t('preprint.submitStepsAuthor') }}</span>
        <el-divider></el-divider>
      </el-col>

      <el-col
        @click.native="currentComponent = 'preprintFileComponent'"
        :class="{ active: currentComponent === 'preprintFileComponent' }"
        class="catelog"
      >
        <span class="catelog_text">{{ $t('preprint.submitStepsFile') }}</span>
        <el-divider></el-divider>
      </el-col>

      <el-col
        @click.native="currentComponent = 'preprintSubmitComponent'"
        :class="{ active: currentComponent === 'preprintSubmitComponent' }"
        class="catelog"
      >
        <span class="catelog_text">{{ $t('preprint.submitStepsSubmit') }}</span>
        <el-divider></el-divider>
      </el-col>
    </el-col>

    <el-col :span="17" class="mybody right">
      <component :is="currentComponent"></component>
    </el-col>
  </div>
</template>

<script>
import preprintInfoComponent from '@/components/preprint/preprintInfoComponent'
import preprintAuthorComponent from '@/components/preprint/preprintAuthorComponent'
import preprintFileComponent from '@/components/preprint/preprintFileComponent'
import preprintSubmitComponent from '@/components/preprint/preprintSubmitComponent'

export default {
  name: 'submitPreprint',
  components: {
    preprintInfoComponent,
    preprintAuthorComponent,
    preprintFileComponent,
    preprintSubmitComponent
  },
  data() {
    return {
      currentComponent: 'preprintInfoComponent',
      userInfo: null,
      preprintId: null,
      mode: 'new',
      preprintData: null
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'myPreprintList' })
    },
    async loadPreprintData() {
      if (!this.preprintId) return

      try {
        const { getPreprintDetail } = await import('@/api/preprint')
        const res = await getPreprintDetail({ id: this.preprintId })
        
        console.log('=== 加载预印本数据 ===')
        console.log('预印本ID:', this.preprintId)
        console.log('返回数据:', res.data)
        
        if (res.data.errorCode === 0) {
          this.preprintData = res.data.result
          console.log('预印本详情:', this.preprintData)
          console.log('作者信息:', this.preprintData.authors)
          console.log('文件信息:', this.preprintData.manuscriptFilePath, this.preprintData.manuscriptFileName)
          
          // 直接将数据存储到 sessionStorage，让子组件读取
          if (this.preprintData.title) {
            const preprintInfo = {
              title: this.preprintData.title,
              preprintType: this.preprintData.preprintType,
              abstractText: this.preprintData.abstractText,
              keywords: this.preprintData.keywords
            }
            sessionStorage.setItem('preprintInfo', JSON.stringify(preprintInfo))
            console.log('保存预印本信息到 sessionStorage:', preprintInfo)
          }
          
          if (this.preprintData.authors && this.preprintData.authors.length > 0) {
            const authors = this.preprintData.authors.map((author, index) => ({
              authorName: author.authorName || '',
              authorEmail: author.authorEmail || '',
              authorAffiliation: author.authorAffiliation || '',
              authorOrder: index + 1,
              isCorresponding: author.isCorresponding || false
            }))
            sessionStorage.setItem('preprintAuthors', JSON.stringify(authors))
            console.log('保存作者信息到 sessionStorage:', authors)
          }
          
          if (this.preprintData.manuscriptFilePath) {
            const fileInfo = {
              fileName: this.preprintData.manuscriptFileName || '已上传文件',
              filePath: this.preprintData.manuscriptFilePath
            }
            sessionStorage.setItem('preprintFile', JSON.stringify(fileInfo))
            console.log('保存文件信息到 sessionStorage:', fileInfo)
          }
          
          // 触发事件通知子组件刷新（作为备用方案）
          this.$nextTick(() => {
            console.log('触发 loadPreprintData 事件')
            this.$root.$emit('loadPreprintData', this.preprintData)
            // 强制刷新当前组件
            this.currentComponent = ''
            this.$nextTick(() => {
              this.currentComponent = 'preprintInfoComponent'
            })
          })
        } else {
          this.$message.error('加载预印本数据失败')
          this.$router.push({ name: 'myPreprintList' })
        }
      } catch (err) {
        console.error('加载预印本数据错误:', err)
        this.$message.error('加载预印本数据失败')
        this.$router.push({ name: 'myPreprintList' })
      }
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    if (!this.userInfo) {
      this.$message.error(this.$t('preprint.needLogin'))
      this.$router.push({ name: 'login' })
      return
    }

    // 检查是否是重新提交模式
    this.preprintId = this.$route.query.preprintId
    this.mode = this.$route.query.mode || 'new'

    if (this.mode === 'resubmit' && this.preprintId) {
      // 延迟加载，确保所有子组件都已挂载
      setTimeout(() => {
        this.loadPreprintData()
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin: auto;
}

.title {
  height: 1200px;
  background-color: white;
  border: 1px solid #b3c0d1;
  border-radius: 6px;
  overflow: hidden;
}

.jump {
  font-weight: 900;
  cursor: pointer;
}

/* 菜单项容器 - 统一盒模型 */
.catelog {
  cursor: pointer;
  text-align: left;
  /* 关键修复1: 移除上下 padding，让内容区域和边框区域分离 */
  padding: 0;
  color: #333333;
  transition: all 0.3s ease;
  position: relative;
  /* 关键修复2: 使用 flex 布局确保内容垂直居中 */
  display: flex;
  flex-direction: column;
}

/* 文字内容区域 - 这里设置真正的 padding */
.catelog_text {
  color: #333333;
  /* 关键修复3: padding 只在文字区域，确保点击区域与视觉区域一致 */
  padding: 12px 0 12px 30px;
  /* 关键修复4: flex-grow 让文字区域撑满，但不包括 divider */
  flex: 0 0 auto;
}

.catelog:hover {
  background-color: #f5f5f5;
}

.catelog:hover .catelog_text {
  background-color: #f5f5f5;
}

/* 选中态 - 背景色只在文字区域 */
.active .catelog_text {
  background-color: #f0f9ff;
  color: #006a71 !important;
  font-weight: 600;
}

/* 关键修复5: 蓝色左边框只覆盖文字区域，使用精确定位 */
.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  /* 关键修复6: 高度 = 文字区域的高度，不包括 divider */
  /* 通过 calc 计算：文字的 padding-top + 文字行高 + padding-bottom */
  height: calc(1.5em + 24px); /* 1.5em 约等于文字行高，24px = 12px*2 padding */
  width: 4px;
  background-color: #006a71;
  /* 关键修复7: 使用 z-index 确保在背景之上 */
  z-index: 1;
}

/* 备选方案：如果上面的 calc 不够精确，使用 bottom 定位到 divider 上方 */
/* 
.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 1px;
  width: 4px;
  background-color: #006a71;
  z-index: 1;
}
*/

.right {
  height: 1200px;
  border: 1px solid #b3c0d1;
  border-radius: 6px;
  background-color: white;
  margin-left: 10px;
  overflow: auto;
}

.header {
  padding: 12px 10px;
  text-align: left;
  background-color: #e8e8e8;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid #d0d0d0;
}

/* 关键修复8: divider 保持 margin 0，但确保不影响布局 */
.el-divider {
  margin: 0;
  /* 关键修复9: 确保 divider 不占用额外空间 */
  flex-shrink: 0;
}

/* 关键修复10: 移除 el-col 可能的默认 padding */
>>> .el-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/preprint/submitPreprint.vue